import React, { ReactElement } from "react";

import { Button, Col } from "react-bootstrap";

import classNames from "classnames";
import { Link } from "react-router-dom";

import styles from "./BannerTwoToTwoCols.module.scss";

const BannerTwoToTwoCols = ({
  heading,
  columnOneContent,
  columnTwoContent,
}: {
  heading: string;
  columnOneContent: {
    columnHeading: string;
    columnContent: string | ReactElement;
    buttonLabel: string;
    href: string;
  };
  columnTwoContent: {
    columnHeading: string;
    columnContent: string | ReactElement;
    buttonLabel: string;
    href: string;
  };
}) => {
  return (
    <div className={classNames(styles["banner-container"], "px-3 px-md-0")}>
      <div>
        <div className="h2 mb-5 pb-5">{heading}</div>
        <div className={classNames(styles["banner-inner-container"], "d-md-flex flex-column flex-md-row")}>
          <Col md={5} className="d-flex flex-column pb-5 pb-md-0">
            <div className="h4 mb-3">{columnOneContent.columnHeading}</div>
            <div className="monoBlack b3 mb-5">{columnOneContent.columnContent}</div>
            <Link to={columnOneContent.href} target="_blank" rel="noopener noreferrer" className="align-self-center">
              <Button variant="secondary" role="link" className={styles["banner-button"]} size="lg">
                {columnOneContent.buttonLabel}
              </Button>
            </Link>
          </Col>
          <Col md={5} className="d-flex flex-column">
            <div className="h4 mb-3">{columnTwoContent.columnHeading}</div>
            <div className="monoBlack b3 mb-5">{columnTwoContent.columnContent}</div>
            <Link to={columnTwoContent.href} target="_blank" rel="noopener noreferrer" className="align-self-center">
              <Button variant="secondary" role="link" className={styles["banner-button"]} size="lg">
                {columnTwoContent.buttonLabel}
              </Button>
            </Link>
          </Col>
        </div>
      </div>
    </div>
  );
};

export default BannerTwoToTwoCols;
